<template>
    <div v-if="modalShow">
        <b-modal id="RemoveShareholderModal" title="Eliminar el socio" centered scrollable header-bg-variant="dark"
            v-model="modalShow">

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()" :disabled="isLoading">
                    Cerrar
                </b-button>

            </template>

            <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

            <!-- cuerpo de cart -->
            <p>
                ¿Desea eliminar
                <strong>{{ child.name }}</strong>
                de la lista de
                {{ parentTypeLabel }} de
                <strong>{{ parent.name }}</strong>?
            </p>

            <!-- fooder -->
            <template #modal-footer>
                <div class="w-100">
                    <b-button v-on:click="handleRemoveShareholder()" variant="outline-danger" :disabled="isLoading">
                        <b-spinner v-if="isLoading" class="me-2" small></b-spinner>
                        Eliminar
                    </b-button>
                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import {EventNames} from "@/plugins/enums";
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';

export default {
    name: 'ShareholderAssignementRemove',

    data() {
        return {
            modalShow: false,
            child: null,
            parent: null,
            parentTypeLabel: parent.type !== 'instance' ? 'socios' : 'companías administradas',
            isLoading: false,
        }
    },

    components: {
        AlertDismiss
    },

    async mounted() {
        this.$eventBus.$on(EventNames.OpenModalRemoveShareholder, async (data) => {
            this.child = data.child;
            this.parent = data.parent;
            this.modalShow = true;
        });
    },

    methods:{
        ...mapActions(["deleteShareholder"]),


        closeModal() {
            this.modalShow = false;
        },

        async handleRemoveShareholder(){
            this.isLoading = true;
            let result = await this.deleteShareholder({ parentNodeId: this.parent.id, childNodeId: this.child.id });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.isLoading = false;
                return;
            }

            this.isLoading = false;
            this.$eventBus.$emit(EventNames.ShowAlertManagedCompanies, {
                msg: 'Socio eliminado correctamente',
                type: 'success'
            });

            this.$eventBus.$emit(EventNames.UpdateShareholderStructure)
            
            this.modalShow = false;
        }
    }
}
</script>
<style>
    
</style>